import EditionBox from 'Editor/modals/NewListModal/FormattingPane/EditionBox';
import RegularBox from 'Editor/modals/NewListModal/FormattingPane/RegularBox';
import IrregularBox from 'Editor/modals/NewListModal/FormattingPane/IrregularBox';

import styles from 'Editor/modals/NewListModal/NewListModal.module.scss';
import { Props } from './types';
import { EmptyState } from '@ets/design-system';
import { useIntl } from 'react-intl';

export const FormattingPane = ({ type, applyStylesToAll, ...props }: Props) => {
  const intl = useIntl();

  const formattingPaneSize = () => {
    if (type === 'outline_numbered') {
      return '47rem';
    } else {
      return '53rem';
    }
  };

  const renderEmptyState = () => {
    return (
      <EmptyState
        size="m"
        title={intl.formatMessage({ id: 'NO_LIST_LEVEL_SELECTED' })}
        description={intl.formatMessage({ id: 'SELECT_A_LIST_LEVEL_TO_SEE_ITS_INFORMATION_HERE' })}
        testId="no-list-level-selected"
      />
    );
  };

  if (!Number.isInteger(props.selectedLine)) {
    return (
      <div
        className={`${styles.emptyState} ${(props.customize || type === 'outline_numbered') && styles.customizeEmptyState}`}
        style={{ width: formattingPaneSize() }}
      >
        {renderEmptyState()}
      </div>
    );
  } else {
    return (
      <div
        className={`${styles.formattingPane} ${props.customize && styles.customizeFormattingPane}`}
        style={{ width: formattingPaneSize() }}
      >
        <EditionBox header={type !== 'bullet' ? 'NUMBER_FORMATTING' : 'BULLET_FORMATTING'}>
          {type === 'outline_numbered' ? (
            <RegularBox type={type} leftText="numbering_type" rightText="start_from" {...props} />
          ) : (
            <IrregularBox type={type} {...props} />
          )}
        </EditionBox>
        {type !== 'bullet' && (
          <EditionBox header="CHARACTER_FORMATTING" applyStylesToAll={applyStylesToAll}>
            <RegularBox type={type} leftText="char_before" rightText="char_after" {...props} />
          </EditionBox>
        )}
        <EditionBox header="INDENTATION">
          <RegularBox
            type={type}
            leftText="indentation_left"
            rightText="indentation_right"
            {...props}
          />
        </EditionBox>
      </div>
    );
  }
};

export default FormattingPane;
